export default __webpack_public_path__ + "static/media/Support Button (4).4b11bd57.svg";